(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else if (!root.DSDOriginalsPlaybackObserver) root.DSDOriginalsPlaybackObserver = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  var UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  var ID = /^[a-z0-9][a-z0-9-]{0,79}$/;
  var REVISION = /^[a-zA-Z0-9][a-zA-Z0-9._-]{0,119}$/;

  function create(audio, options) {
    if (!audio || !options || typeof options.sessionId !== 'function') throw new Error('playback_observer_config_invalid');
    var endpoint = String(options.endpoint || '/apps/dsd-firebase-custom-token/originals').replace(/\/+$/, '');
    var clock = typeof options.now === 'function' ? options.now : function () { return performance.now(); };
    var send = typeof options.send === 'function' ? options.send : function (url, body) {
      return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify(body), keepalive: true }).then(function (response) {
        if (!response.ok) { var error = new Error('playback_observation_failed'); error.status = response.status; throw error; }
      });
    };
    var context = null;
    var activeId = null;
    var started = false;
    var lastMedia = null;
    var lastWall = null;
    var pendingStart = null;
    var pendingEnd = null;
    var queue = [];
    var sending = false;
    var disabled = false;
    var generation = 0;

    function validContext(value) {
      return value && value.enabled === true && ID.test(String(value.chapterId || '')) && REVISION.test(String(value.audioRevision || '')) &&
        (options.requireAccountScope !== true || /^[a-f0-9]{32}$/.test(String(value.progressScope || '')));
    }
    function resetAnchor() { lastMedia = null; lastWall = null; }
    function url() { return endpoint + '/playback?chapterId=' + encodeURIComponent(context.chapterId) + '&audioRevision=' + encodeURIComponent(context.audioRevision); }
    function pump() {
      if (sending || disabled || !queue.length) return;
      sending = true;
      var item = queue[0];
      Promise.resolve().then(function () { return send(item.url, item.body); }).then(function () {
        var index = queue.indexOf(item); if (index >= 0) queue.splice(index, 1);
        sending = false; pump();
      }).catch(function (error) {
        sending = false;
        if (error && [400, 401, 403, 404, 409].includes(Number(error.status))) {
          var index = queue.indexOf(item); if (index >= 0) queue.splice(index, 1);
          if (item.generation === generation) { disabled = true; queue = []; }
          else pump();
        }
      });
    }
    function enqueue(item) {
      if (!context || disabled || queue.length >= 64) return;
      queue.push({ url: url(), body: Object.assign({ sessionId: activeId }, context.progressScope ? { progressScope: context.progressScope } : {}, item), generation: generation });
      pump();
    }
    function flushRange() {
      if (pendingStart !== null && pendingEnd > pendingStart) {
        var start = pendingStart;
        while (start < pendingEnd) {
          var end = Math.min(pendingEnd, start + 25);
          if (end <= start) break;
          enqueue({ event: 'observe', rangeStart: start, rangeEnd: end });
          start = end;
        }
      }
      pendingStart = null; pendingEnd = null;
    }
    function sample(force) {
      if (!context || !started || disabled || (!force && audio.paused)) return;
      var media = Number(audio.currentTime);
      var wall = Number(clock());
      if (!Number.isFinite(media) || !Number.isFinite(wall)) return;
      if (lastMedia !== null) {
        var delta = media - lastMedia;
        var elapsed = Math.max(0, (wall - lastWall) / 1000);
        var speed = Math.max(0.5, Math.min(2.5, Number(audio.playbackRate) || 1));
        if (delta > 0.03 && delta <= 30 && delta <= elapsed * speed + 1.5) {
          if (pendingStart !== null && Math.abs(lastMedia - pendingEnd) > 0.5) flushRange();
          if (pendingStart === null) pendingStart = lastMedia;
          pendingEnd = media;
          if (pendingEnd - pendingStart >= 25) flushRange();
        } else if (Math.abs(delta) > 0.5) flushRange();
      }
      lastMedia = media; lastWall = wall;
    }
    function playing() {
      if (!context || disabled) return;
      var id = String(options.sessionId() || '');
      if (!UUID.test(id)) return;
      if (id !== activeId) { flushRange(); activeId = id; started = false; resetAnchor(); }
      if (!started) { started = true; enqueue({ event: 'start' }); }
      lastMedia = Number(audio.currentTime); lastWall = Number(clock());
    }
    function pause() { sample(true); flushRange(); resetAnchor(); pump(); }
    function seeking() { flushRange(); resetAnchor(); }
    function ended() { sample(true); flushRange(); if (started) enqueue({ event: 'ended' }); started = false; resetAnchor(); }
    audio.addEventListener('playing', playing);
    audio.addEventListener('timeupdate', function () { sample(false); pump(); });
    audio.addEventListener('seeking', seeking);
    audio.addEventListener('pause', pause);
    audio.addEventListener('ended', ended);

    return {
      setContext: function (value) {
        var next = validContext(value) ? { chapterId: value.chapterId, audioRevision: value.audioRevision,
          progressScope: typeof value.progressScope === 'string' ? value.progressScope : null } : null;
        if (context && next && context.chapterId === next.chapterId && context.audioRevision === next.audioRevision && context.progressScope === next.progressScope) return;
        flushRange();
        context = next;
        generation += 1; activeId = null; started = false; disabled = false; resetAnchor(); pump();
      },
      flush: function () { sample(true); flushRange(); pump(); },
      status: function () { return { enabled: Boolean(context), started: started, queued: queue.length, disabled: disabled }; }
    };
  }

  return { create: create };
});
